import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
  DiJava,
} from "react-icons/di";
import {
  SiRedis,
  SiFirebase,
  SiSolidity,
  SiPostgresql,
  SiAmazonaws,
  SiNginx,
  SiGithub,
  SiGitlab,
  SiMysql,
  SiPhp,
  SiPhpmyadmin,
  SiPytorch,
  SiBootstrap,
  SiCss3,
  SiApache,
  SiDigitalocean,
  SiNumpy,
  SiCodeigniter,
  SiLaravel,
  SiFlutter,
  SiDart,
  SiNestjs,
  SiTypescript,
  SiDotnet,
  SiDotenv,
  SiNpm,
  SiYarn,
  SiNodemon,
} from "react-icons/si";
import { TbBrandGolang } from "react-icons/tb";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <CgCPlusPlus />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <TbBrandGolang />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSolidity />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFirebase />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiRedis />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostgresql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiPython />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJava />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <SiGithub />
    </Col>
    <Col xs={4} md={2} className="tech-icons">
      <SiGitlab />
    </Col>
    <Col xs={4} md={2} className="tech-icons">
      <SiAmazonaws />
    </Col>
    <Col xs={4} md={2} className="tech-icons">
      <SiNginx />
    </Col>
    <Col xs={4} md={2} className="tech-icons">
      <SiMysql />
    </Col>
    <Col xs={4} md={2} className="tech-icons">
      <SiPhp />
    </Col>
    <Col xs={4} md={2} className="tech-icons">
      <SiPhpmyadmin />
    </Col>
    <Col xs={4} md={2} className="tech-icons">
      <SiPytorch />
    </Col>
    <Col xs={4} md={2} className="tech-icons">
      <SiBootstrap />
    </Col>
    <Col xs={4} md={2} className="tech-icons">
      <SiCss3 />
    </Col>
    <Col xs={4} md={2} className="tech-icons">
      <SiApache/>
    </Col>
    <Col xs={4} md={2} className="tech-icons">
        <SiDigitalocean />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiNumpy />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiCodeigniter />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiLaravel />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFlutter />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiDart />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiNestjs />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTypescript />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiDotnet />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiDotenv />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiNpm />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiYarn />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiNodemon />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiApache />
      </Col>

    </Row>
  );
}

export default Techstack;
